<template>
	<nav>

		<Modal v-if="custom_email" v-on:close="custom_email = false">
			<CustomEmailSender />
		</Modal>

		<div class="nav-wrapper">
			<div class="logo">
				<SvgIcon v-on:click="toggleSidebar" :name="isSidebarOpen ? 'sidebar-close' : 'sidebar-open'" class="small-margin-right clickable" />
				<a href="/#/"><img :src="`${storage_url}/img/logo.png`" /></a>
			</div>
			<div class="navigation">
				<div class="menu-item">
					<div class="title">Products</div>
					<div class="items">
						<div class="group-title">Products</div>
						<router-link to="/products/create">
							<a>Create product</a>
						</router-link>
            <router-link to="/products/bulk-update">
							<a>Product bulk update</a>
						</router-link>
            <router-link to="/products/styles">
							<a>Styles</a>
						</router-link>
            <router-link to="/products/troubleshoot">
              <a>Troubleshoot</a>
            </router-link>

						<div class="group-title">Attributes</div>
						<router-link to="/products/missing-size-conversions">
							<a>Missing size conversions</a>
						</router-link>

						<div class="group-title">Inventory</div>
						<router-link to="/inventory-cache">
							<a>Inventory cache</a>
						</router-link>
						<router-link to="/warehouse-products">
							<a>Warehouse products</a>
						</router-link>
						<router-link to="/purchase-orders">
							<a>Purchase orders</a>
						</router-link>

						<div class="group-title">Discounts</div>
						<router-link to="/discounts">
							<a>Discounts</a>
						</router-link>
					</div>
				</div>

				<div class="menu-item">
					<div class="title">Styling</div>
					<div class="items">
						<div class="group-title">Stylings</div>
            <router-link to="/stylist/orders">
							<a>CX orders</a>
						</router-link>

						<div class="group-title">Performance</div>
						<router-link to="/stylist/performance-overview">
							<a>Performance Overview</a>
						</router-link>

						<div class="group-title">Statistics</div>
						<router-link to="/subscriptions/statistics/sneak-peek">
							<a>Sneak peeks</a>
						</router-link>
            <router-link to="/subscriptions/statistics/sneak-peek-complete">
							<a>Sneak peeks complete</a>
						</router-link>
						<router-link to="/move-renewals">
							<a>Move renewals</a>
						</router-link>
					</div>
				</div>

				<div class="menu-item">
					<div class="title">Orders</div>
					<div class="items">
						<div class="group-title">Orders</div>
						<router-link to="/orders">
							<a>Orders</a>
						</router-link>
            <router-link to="/deposits">
              <a>Deposits</a>
            </router-link>
            <router-link to="/pick2sp">
              <a>Pick2SP Schedule</a>
            </router-link>

            <div class="group-title">Shipments</div>
						<router-link to="/return-orders">
							<a>Returns</a>
						</router-link>
						<router-link to="/lost-shipments">
							<a>Lost shipments</a>
						</router-link>
						<router-link to="/ocean-package-returns">
							<a>Ocean Package file</a>
						</router-link>

            <div class="group-title">Batch</div>
            <router-link to="/orders-batch-operation">
              <a>Batch operate orders</a>
            </router-link>
					</div>
				</div>

				<div class="menu-item">
					<div class="title">Economy</div>
					<div class="items">
						<div class="group-title">Transactions</div>
						<router-link to="/bank-payments">
							<a>Bank payments</a>
						</router-link>
            <router-link to="/bulk-bank-payment">
              <a>Bulk bank payments</a>
            </router-link>

						<div class="group-title">Credit check &amp; debt</div>
						<router-link to="/credit/check">
							<a>Credit Check</a>
						</router-link>
						<router-link to="/debt-collection">
							<a>Debt collection</a>
						</router-link>

						<div class="group-title">Accounting</div>
						<router-link to="/balance-requests">
							<a>Uniconta balance requests</a>
						</router-link>

            <div class="group-title">Discounts</div>
            <router-link to="/bulk-discount">
              <a>Bulk discount</a>
            </router-link>
					</div>
				</div>

				<div class="menu-item">
					<div class="title">Advanced</div>
					<div class="items">
						<div class="group-title">Communication</div>
						<router-link to="/translations">
							<a>Translations</a>
						</router-link>
						<router-link to="/email-templates">
							<a>Email templates</a>
						</router-link>

						<div class="group-title">Misc.</div>
						<router-link to="/cronjob-performance">
							<a>Cronjob performance</a>
						</router-link>
            <router-link to="/blocked/address">
							<a>Blocked Address</a>
						</router-link>
            <router-link to="/blocked/phone">
							<a>Blocked Phone</a>
						</router-link>
            <router-link to="/queue/push">
              <a>Push items in Queue</a>
            </router-link>

						<div class="group-title">Admin</div>
						<router-link to="/users">
							<a>Users</a>
						</router-link>

						<div class="group-title">Styling settings</div>
						<router-link to="/set-goals">
							<a>Set goals</a>
						</router-link>
						<router-link to="/styling-model-categories">
							<a>Styling model categories</a>
						</router-link>

						<template v-if="getEnvironment() != 'production'">
							<div class="group-title">Testing</div>
							<router-link to="/testing">
								<a>Testing</a>
							</router-link>
							<router-link to="/testing/cronjobs">
								<a>Cronjobs</a>
							</router-link>
							<router-link to="/testing-templates">
								<a>Testing templates</a>
							</router-link>
						</template>
					</div>
				</div>

			</div>
			<div class="account-links">
				<div class="account-link" v-on:click="custom_email = !custom_email">
					<div class="icon">
						<SvgIcon name="email" />
					</div>
					<div class="text">
						Send custom email
					</div>
				</div>
				<div class="account-link" v-on:click="setBox('notifications')">
					<div class="icon">
						<SvgIcon name="track" />
					</div>
					<div class="text">
						Notifications
					</div>
				</div>
				<div class="account-link" v-on:click="setBox('account')">
					<div class="icon">
						<SvgIcon name="account" />
					</div>
					<div class="text">
						<template v-if="getToken">{{ getStylist.first_name }}</template>
						<template v-else>Log in</template>
					</div>
					<div class="not-loggedin-flash" v-if="!getToken"></div>
				</div>
				<div class="account-link" v-on:click="setBox('search')">
					<div class="icon">
						<SvgIcon name="search" />
					</div>
					<div class="text">
						Search
					</div>
				</div>
			</div>
		</div>

		<div class="account-box" v-if="dropdown == 'account'">
			<template v-if="getToken">
				<h3 style="margin: 0px; margin-bottom: 30px;">{{ getStylist.first_name }}</h3>

				<div class="margin-bottom">
					<div class="small-margin-bottom">
						<strong>Change password</strong>
					</div>
					<div class="flex">
						<MaterialText
							:disabled="saving"
							v-on:enter="changePassword"
							:password="true"
							v-model="password_current"
							label="Current"
							:width="130" />

						<MaterialText
							:disabled="saving"
							v-on:enter="changePassword"
							:password="true"
							v-model="password_new"
							label="New password"
							:width="130"
							class="small-margin-left" />

						<MaterialText
							:disabled="saving"
							v-on:enter="changePassword"
							:password="true"
							v-model="password_confirm"
							label="Confirm"
							:width="130"
							class="small-margin-left" />
					</div>
					<div class="note small-margin-top">
						Press ENTER to change the password
					</div>
				</div>

				<div class="margin-top border-top padding-top flex">
					<div>
						<MaterialText v-model="color" :disabled="saving" v-on:enter="updateColor()" label="Your color" />
					</div>
					<div class="margin-left">
						<div :style="'width: 26px; height: 26px; background: ' + color"></div>
					</div>
				</div>

				<div class="margin-top border-top padding-top">
					<h2 class="no-margin">
						Low data mode:
						<template v-if="isLowDataMode">ON</template>
						<template v-else>OFF</template>
					</h2>

					<div class="margin-top">
						<button v-on:click="setDataMode(false)" v-if="isLowDataMode">Disable low data mode</button>
						<button v-on:click="setDataMode(true)" v-else>Enable low data mode</button>
					</div>
				</div>

				<div class="margin-top border-top padding-top">
					<button v-on:click="logout">Log out</button>
				</div>
			</template>
			<template v-else>
				<Login />
			</template>
		</div>

		<div class="account-box" v-if="dropdown == 'search'">
			<MaterialText ref="search" v-model="term" v-on:enter="search" :disabled="searching" label="Search" />
			<div class="margin-top">

				<div v-if="show_no_results">No results :-/</div>

				<div v-for="result in results">

					<template v-if="result.type == 'customer'">
						<div class="flex align-items clickable search-result" v-on:click="goTo(result)">
							<Flag :localeid="result.locale.locale_id" />
							<SvgIcon class="very-small-margin-left search-icon" name="customer" />
							<div class="very-small-margin-left">
								{{ result.full_name }}
							</div>
						</div>
					</template>

					<template v-if="result.type == 'order'">
						<div class="flex align-items clickable search-result" v-on:click="goTo(result)">
							<Flag :localeid="result.locale.locale_id" />
							<div class="very-small-margin-left">
								Order {{ result.id }}
							</div>
						</div>
					</template>

					<template v-if="result.type == 'product'">
						<div class="flex align-items clickable search-result" v-on:click="goTo(result)">
							<SvgIcon class="very-small-margin-right search-icon" name="product" />
							<div>
								{{ result.sku ? result.sku : 'Product' }}
								({{ result.id }})
							</div>
						</div>
					</template>

					<template v-if="result.type == 'subscription'">
						<div class="flex align-items clickable search-result" v-on:click="goTo(result)">
							<SvgIcon class="very-small-margin-right search-icon" name="subscription" />
							<div>
								Subscription
								({{ result.id }})
							</div>
						</div>
					</template>

				</div>
			</div>
		</div>

		<Notifications v-on:push="push()" v-show="dropdown == 'notifications'" />

	</nav>
</template>

<style lang="less" scoped>
	.group-name {
		font-size: 14px;
		padding: 15px;
		padding-top: 25px;
		padding-bottom: 5px;
		color: #888;
		font-weight: 900;
		text-transform: uppercase;
		cursor: default;
	}
</style>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Login from '@/components/Login.vue'
import Notifications from '@/components/Notifications.vue'

export default {
  data: () => ({
    term: '',
    searching: false,
    saving: false,
    dropdown: false,
    results: [],
    show_no_results: false,
    password_current: '',
    password_confirm: '',
    password_new: '',
    color: '',
    custom_email: false,
    storage_url: process.env.VUE_APP_CDN_BASE_URL
  }),
  components: {
    Login,
    Notifications
  },
  computed: {
    ...mapGetters([
      'getToken',
      'getStylist',
      'isLowDataMode',
      'isSidebarOpen'
    ])
  },
  methods: {
    getEnvironment () {
    	const hostname = location.hostname
    	if (hostname.match(/^dashboard(\-preprod)?\.annoanno\.[a-z]{2,3}$/)) {
    		return 'production'
    	}
      return Vue.$env.get()
    },
    toggleSidebar () {
      this.$store.commit('setSidebarOpen', !this.isSidebarOpen)
    },
    setDataMode (low) {
      this.$store.commit('setLowDataMode', low)
    },
    push () {
      this.dropdown = 'notifications'
    },
    changePassword () {
      Vue.$api.put('/stylist/password', {
        current: this.password_current,
        password: this.password_new,
        confirm: this.password_confirm
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => {
          this.password_current = ''
          this.password_new = ''
          this.password_confirm = ''

          alert('Password changed')
        }
      })
    },
    goTo (object) {
      var url = '/customer/' + object.id
      if (object.type == 'order') {
        url = '/order/' + object.id
      } else if (object.type == 'product') {
        url = '/product/' + object.id
      } else if (object.type == 'subscription') {
        url = '/subscription/' + object.id
      }

      this.$router.push(url)

      this.term = ''
      this.dropdown = false
      this.results = []

      this.$router.go(0)
    },
    setBox (menu) {
      if (this.dropdown == menu) {
        this.dropdown = false
      } else {
        this.dropdown = menu
      }

      if (this.dropdown == 'search') {
        setTimeout(() => {
          this.$refs.search.focus()
        }, 50)
      }
    },
    search () {
      this.show_no_results = false

      if (this.term) {
        Vue.api.get('/search/freetext?search=' + this.term, {}, {
          before: () => this.searching = true,
          always: () => this.searching = false,
          callback: (data) => this.parse(data)
        })
      }
    },
    parse (data) {
      this.results = data

      if (!this.results.length) {
        this.show_no_results = true
      } else if (this.results.length == 1) {
        this.goTo(this.results[0])
      }
    },
    logout () {
      this.$store.commit('setToken', '')
      this.$store.commit('setStylist', {})
    },
    updateColor () {
      Vue.$api.patch('/user/color', {
        color: this.color
      }, {
        loader: toggle => this.saving = toggle,
        callback: () => this.$store.commit('setStylistColor', this.color)
      })
    }
  },
  created () {
    this.color = this.getStylist.color
  }
}
</script>
